/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_Too_EasyInputs */

const en_ui_te_summary_too_easy = /** @type {(inputs: Ui_Te_Summary_Too_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too easy to produce a meaningful training stimulus.`)
};

const de_ui_te_summary_too_easy = /** @type {(inputs: Ui_Te_Summary_Too_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu leicht für einen echten Trainingsreiz.`)
};

/**
* | output |
* | --- |
* | "Too easy to produce a meaningful training stimulus." |
*
* @param {Ui_Te_Summary_Too_EasyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_too_easy = /** @type {((inputs?: Ui_Te_Summary_Too_EasyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_Too_EasyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_too_easy(inputs)
	return de_ui_te_summary_too_easy(inputs)
});